/**
 * Style constants.
 * Contains styling-related constants used across components.
 *
 * @module constants/styles
 */

import { MARKETING_COLORS } from '@vp/marketing-colors'

/** CSS class name for the holiday navigation skin */
export const SITE_HEADER_NAV_SKIN_HOLIDAY = 'site-header-nav-skin-holiday'

/** Hex color code for holiday red theme */
export const HOLIDAY_RED_COLOR_CODE = MARKETING_COLORS['holiday']?.code
